import { render } from "./admin-layers.vue?vue&type=template&id=70c2d770&ts=true&lang=pug"
import script from "./admin-layers.vue?vue&type=script&lang=ts"
export * from "./admin-layers.vue?vue&type=script&lang=ts"

import "./admin-layers.vue?vue&type=style&index=0&id=70c2d770&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__